import './AntragBadge.css';
import { Badge } from '@efast_public/fjd-component-library';

interface AntragBadgeProps {
  readonly 'data-testid'?: string;
}

export default function AntragBadge(props: AntragBadgeProps) {
  return (
    <Badge
      data-testid={props['data-testid']}
      variant={'neutral'}
      label={'Antrag'}
      size="xs"
    />
  );
}
